import { Provider } from "react-redux";
import { Store } from "redux";
import { useRouter } from "next/router";
import Script from "next/script";
import "main/styles/globals.css";
import "react-toastify/dist/ReactToastify.min.css";
import { wrapper as adminWrapper } from "admin/store";
import { wrapper as mainWrapper } from "main/store";
import { GTM_SCRIPT } from "lib/gtm";

function HotelApp({ Component, ...rest }) {
  const router = useRouter();
  const isAdmin = /^\/(admin|manager)/.test(router.pathname);
  const wrapper = isAdmin ? adminWrapper : mainWrapper;
  const { store, props } = wrapper.useWrappedStore(rest);
  return (
    <>
      <Script
        id="global-google-tag-manager"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: GTM_SCRIPT,
        }}
      />
      <Provider store={store as Store<any>}>
        <Component {...props.pageProps} />
      </Provider>
    </>
  );
}

export default HotelApp;
